<div class="form-element image-uploader">
  <div class="d-flex justify-content-between align-items-center">
    <label>{{ label }}</label>

    @if (tooltip) {
      <div class="tooltip-content">
        <i class="fas fa-info-circle"></i>
        <app-tooltip position="tr">
          <p>{{ tooltip }}</p>
        </app-tooltip>
      </div>
    }
  </div>

  @if (!disabled && control?.value?.length <= maxCount - 1) {
    <cap-file-upload
      #capFileUpload
      styleClass="g-uploader no-print"
      [id]="getControlName()"
      [label]="''"
      [multiple]="multiple"
      [accept]="fileExtensions"
      [uploaderContent]="uploadContent"
      (onFileChange)="addFile($event)">
    </cap-file-upload>
  }

  @if (control?.value?.length) {
    <div class="preview--section">
      <div class="avatar-wrapper">
        <div class="avatar-image" [style.background-image]="'url(' + control?.value[0].public_url + ')'"></div>
        <div class="avatar-actions">
          <i
            class="fas fa-trash-alt avatar--remove no-print"
            (click)="deleteFile(control?.value[0])"
            [attr.title]="'button.delete' | translate"></i>
        </div>
      </div>
    </div>
  }

  <ng-template #uploadContent>
    @if (!disabled) {
      <div class="upload">
        <i class="fas fa-cloud-upload-alt"></i>
        <p [innerHTML]="description ? description : label"></p>
      </div>
    }
  </ng-template>

  @if (control) {
    <cap-validator [control]="control" [customName]="label"></cap-validator>
  }
</div>

<p-confirmDialog #confirmDialog [header]="label" [closable]="false">
  <ng-template #footer>
    <cap-button [label]="'general.yes' | translate" styleClass="primary" (click)="confirmDialog.onAccept()">
    </cap-button>
  </ng-template>
</p-confirmDialog>
